import * as API from '@siloreal:shared:api';

const SILOBAG_ARCHIVED_RESTORE_ENDPOINT = '/silobags/restore';

export type RestoreArchivedSilobagServiceContract = {
  query: string | number;
  signal?: AbortSignal;
};

export type RestoreArchivedSilobagResponse = unknown;

export async function restoreArchivedSilobagService(
  contract: RestoreArchivedSilobagServiceContract
): Promise<RestoreArchivedSilobagResponse> {
  const query = encodeURIComponent(String(contract.query));
  const { data } = await API.http.fetch.post<RestoreArchivedSilobagResponse>(
    `${SILOBAG_ARCHIVED_RESTORE_ENDPOINT}/${query}`,
    {
      signal: contract.signal,
    }
  );

  return data;
}
